<script lang="ts">
    import { Col } from "sveltestrap";
    import Card from "../UiCommenCard.svelte";
    import data from "../../../Data/ComponentData/Ui-kits/Typography/Headings.json";
    import { TextColor } from "../../../utils/Constant/Constant";

</script>
<Col sm="12" xl="6"> 
    <Card cardHeaderprops="pb-0" headerTitle={TextColor} headerContent="You can Give text color by using txt-* class">
      <div slot="contentbody">
        {#each data.primary as fontItem}
          <p class="txt-{fontItem.class}">{fontItem.discription}<code>{fontItem.text}</code> class</p>
        {/each}
      </div>
    </Card>
</Col>